import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import "@/css/main_bootstrap.css"
import 'bootstrap'
import {fas} from '@fortawesome/free-solid-svg-icons'
import {far} from '@fortawesome/free-regular-svg-icons'
import {library} from '@fortawesome/fontawesome-svg-core'
import {FontAwesomeIcon} from '@fortawesome/vue-fontawesome'
import axios, {ParamsSerializerOptions} from "axios";
import JsonUtils from "@/utils/JsonUtils";
import qs from "qs";
import VueAxios from "vue-axios";
import UserInfoDto from "@/dto/UserInfoDto";
import KengenKbn from "@/enums/KengenKbn";
import LoadingUtils from "@/utils/LoadingUtils";
import Dialog from "@/utils/Dialog";
const jsVersionNo = '0.0.3'
let versionOk = false
const initializeApp = async () => {
    library.add(fas)
    library.add(far)
    const app = createApp(App).use(store).use(router)
// eslint-disable-next-line vue/multi-word-component-names
    app.component('fa', FontAwesomeIcon)
    axios.defaults.baseURL = '/api/'
    const axiosClient = axios.create({
        paramsSerializer: ({serialize: (params:any) => {return qs.stringify(params, { arrayFormat: 'repeat' })}}) as ParamsSerializerOptions
        ,timeout:120000
    });
    /**
     * Axiosのリクエストインターセプター
     */
    axiosClient.interceptors.request.use((request) => {
        console.log('@interseptor|' + request.url)
        return request
    })
    axiosClient.interceptors.response.use(
        (response) => {
            const contentType = response.headers['content-type'];
            const serverVersionNo = response.headers['x-server-version'];
            console.log('aop-x-server-version=' + serverVersionNo)
            if(versionOk && jsVersionNo!== serverVersionNo){
                if(location.href.includes('?')){
                    location.href = location.href + '&versionNo=' + serverVersionNo
                }else{
                    location.href = location.href + '?versionNo=' + serverVersionNo
                }
                return response;
            }
            if (typeof contentType === 'string' && contentType.includes('application/json')) {
                try {
                    response.data = JSON.parse(JSON.stringify(response.data), JsonUtils.parse);
                } catch (e) {
                    console.warn('JSON parse error:', e);
                }
            }
            return response;
        },
        (error) => {
            setTimeout(()=>{
                LoadingUtils.end()
            })
            // 失敗時の処理
            switch (error.response?.status) {
                case 403:
                    console.log('>>>>>>>case 403>>>>>>>>' + process.env.VUE_APP_AUTH_SERVER_URL)
                    //location.href = process.env.VUE_APP_AUTH_SERVER_URL + 'sessionTimeout'
                    router.push({path: '/logout'})
                    break
                case 423:
                    Dialog.alert('他のユーザーが修正したデータです。<br/>データを読み直して再度実行して下さい。')
                    break
                case 500:
                    console.log('>>>>>>>500>>>>>>>>')
                    Dialog.alert('システムエラーが発生しました。')
                    break
                default:
                    console.log('>>>>>>>default>>>>>>>>' + error.response?.status)
                    // 例外処理
                    Dialog.alert('ネットワークに接続されていません。')
                    //throw new Error('ネットワークエラー')
                    break
            }
            return Promise.reject(error);
            //throw new Error('サーバーサイドでシステムエラーが発生しました。')
            //return error
        })

    const localVersionNo =  localStorage.getItem('localVersionNo') as string
    const serverVersionNo = (await (await axiosClient).get('getVersionNo')).data as string
    console.log('serverVersionNo=' + serverVersionNo)
    console.log('jsVersionNo=' + jsVersionNo)
    localStorage.setItem('localVersionNo', serverVersionNo)
    if(location.href.includes('versionNo=')){
        if(jsVersionNo!== serverVersionNo){
            console.log('versionNoが異なります。')
            Dialog.alert('バージョンが異なります。<br/>ブラウザを一度終了して下さい。')
            return
        }else{
            Dialog.info('最新のアプリケーションにバージョンアップしました。')
        }
    }else{
        if(jsVersionNo!== serverVersionNo){
            if(location.href.includes('?')){
                location.href = location.href + '&versionNo=' + serverVersionNo
            }else{
                location.href = location.href + '?versionNo=' + serverVersionNo
            }
            return
        }
    }
    console.log('>>>>>>>>>localtion.href1=>>>>>>>>>>' + location.href)
    versionOk = true

// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
    app.use(VueAxios, axiosClient)
    console.log('>>>>>>>>>localtion.href2=>>>>>>>>>>' + location.href)
    try{
        //app.mount('#app')
    }catch (e) {
        console.log('>>>>>>>>>localtion.href2.5=>>>>>>>>>>' + location.href)
    }
    console.log('>>>>>>>>>localtion.href3=>>>>>>>>>>' + location.href)
    router.beforeEach((to: any, from: any, next: any) => {
        if(to.path!=='/' && to.path!=='/logout' && to.path!=='/toroku' && to.path!=='/torokuannai' && !to.path.startsWith('/passwordReminder')){
            axiosClient.get('userInfo').then((res)=>{
                if(res.data){
                    console.log('ルーティング時セッションチェックOK')
                    next()
                }else{
                    console.log('ルーティング時セッションチェックNG=' + to.path)
                    if(res.status){
                        router.push({path: '/'})
                    }
                }
            })
        }else{
            axiosClient.get('getVersionNo').then((res)=>{
                if(res.data===jsVersionNo){
                    next()
                } else {
                    console.warn('バージョンが一致しませんでしたが、画面遷移を継続します');
                    next()
                }
            }).catch((err) => {
                console.error('バージョン取得エラー', err);
                next()
            })
        }
    })
    console.log('>>>>>>>>>localtion.href=>>>>>>>>>>' + location.href)
    const pathname = location.pathname.substring(process.env.VUE_APP_PUBLIC_PATH.length-1)
    if(pathname !== '/toroku' && pathname !== '/torokuannai' && !pathname.startsWith('/passwordReminder')){
        axiosClient.get('userInfo').then((res)=>{
            if(res.data){
                const userInfo = res.data as UserInfoDto
                userInfo.kengenKbn = KengenKbn.getEnum(userInfo.kengenKbnValue) as KengenKbn
                store.commit('setUserInfo', res.data)
                app.mount('#app')
            }else{
                router.push({path: '/'})
                app.mount('#app')
            }
        })
    }else{
        app.mount('#app')
    }
}
initializeApp()